(function() {
    'use strict';
    angular.module('voyageReport')
        .factory('VoyageReportFactory', VoyageReportFactory);

    function VoyageReportFactory() {
        
    	function SearchParamsRequest() {
            this.startDate = null;
            this.endDate = null;
            this.crewProfileId = null;
            this.crewType = null;
            this.crewId = null;
            this.origin = null;
            this.destination = null;
            this.closed = null;
            this.subject = null;
            this.crewComment = null;
            this.adminComment = null;
            this.keywordFilter = null;
        }

        function FormatSearchParams(request) {
            var tmpData = new SearchParamsRequest();
            
            tmpData.startDate = request.fromDate;
            tmpData.endDate = request.toDate;
            tmpData.closed = request.approved;
            tmpData.keywordFilter = request.keywordFilter;
            tmpData.crewType = null;
            
            if (request.origin) {
            	tmpData.origin = request.origin.airPortCode;
            }
            else{
            	tmpData.origin = null;
            }
            if (request.destination){
            	tmpData.destination = request.destination.airPortCode;
            }
            else {
            	tmpData.destination = null;
            }
            if (request.crewDetails) {
                tmpData.crewId = request.crewDetails.crewId;
                tmpData.crewProfileId = request.crewDetails.crewProfileId;
            } else {
                tmpData.crewId = !!request.crewId ? request.crewId : null;
                tmpData.crewProfileId = null;
            }
            if (!!request.crewType) {
                tmpData.crewType = request.crewType.crewTypeCode;
            }
            if(!!request.subject){
            	tmpData.subject = request.subject;
            }
            if(!!request.crewComment){
            	tmpData.crewComment = null;
            }
            if(!!request.adminComment){
            	tmpData.adminComment = null;
            }
            return tmpData;
        }
        return {
            formatSearchParams: FormatSearchParams
        }
    }
})();